import { create } from "zustand";
import type { Role, User } from "../types";
import { logout as logoutApi, me } from "../api/endpoints";

interface UserState {
  user: User | null;
  loading: boolean;
  error: string | null;
  // Роль для отображения UI (admin может переключаться для тестирования).
  viewAs: Role | null;
  load: () => Promise<void>;
  logout: () => Promise<void>;
  setViewAs: (role: Role) => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  // Стартуем в loading: ещё не знаем, авторизованы ли (TG initData или cookie-сессия).
  loading: true,
  error: null,
  viewAs: null,

  async load() {
    set({ loading: true, error: null });
    try {
      const u = await me();
      set({ user: u, loading: false, viewAs: u.role });
    } catch (e) {
      set({ error: (e as Error).message, loading: false });
    }
  },

  async logout() {
    try { await logoutApi(); } catch { /* всё равно сбрасываем локально */ }
    set({ user: null, viewAs: null, error: null, loading: false });
  },

  setViewAs(role: Role) {
    set({ viewAs: role });
  },
}));
